import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HydraoApiServiceBase } from "src/app/core/services/core/hydrao-api.service";

@Injectable({
  providedIn: "root",
})
export class LogService extends HydraoApiServiceBase {
  /**
   * Return places
   */
  public sendLogs(id: string, content: string): Observable<void> {
    let url = `/logfile/${id}`;

    return this.rawPut(url, content, true);
  }
}
